import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=e9dc0f9e"
import script from "./channel.vue?vue&type=script&lang=js"
export * from "./channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9dc0f9e')) {
      api.createRecord('e9dc0f9e', component.options)
    } else {
      api.reload('e9dc0f9e', component.options)
    }
    module.hot.accept("./channel.vue?vue&type=template&id=e9dc0f9e", function () {
      api.rerender('e9dc0f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/channel.vue"
export default component.exports